import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

export function PayproDataProcessingTerms() {
  const { t } = useTranslation();

  return (
    <Stack gap="10px">
      <Typography fontWeight="medium">
        {t('loanFormPage.agreements.form.fields.payproDataProcessing.title')}
      </Typography>
      <Typography sx={{ whiteSpace: 'pre-line' }}>
        {t('loanFormPage.agreements.form.fields.payproDataProcessing.content')}
      </Typography>
    </Stack>
  );
}
